// Pusher events of Inicio on `agent_<userId>` (spec §7). Their payloads carry
// no `type`, so `useBinder` also hands the event name to the handler.
// - taskOffered: { taskId, expiresAt, aiCanDo }
// - taskUpdated: the context or the state changed
// - taskRemoved: expired, reassigned or discarded
export const TASK_OFFERED = 'taskOffered';
export const TASK_UPDATED = 'taskUpdated';
export const TASK_REMOVED = 'taskRemoved';

export const HUMAN_TASK_EVENTS = [TASK_OFFERED, TASK_UPDATED, TASK_REMOVED];
